export const WORK_TYPES = {
  photo: { label: 'Photo', color: '#06B6D4', badge: 'bg-[#06B6D4]' },
  video: { label: 'Video', color: '#8B5CF6', badge: 'bg-[#8B5CF6]' },
  editing: { label: 'Editing', color: '#EC4899', badge: 'bg-[#EC4899]' },
  reels: { label: 'Reels', color: '#D97706', badge: 'bg-[#D97706]' },
  live: { label: 'Live', color: '#059669', badge: 'bg-[#059669]' },
  other: { label: 'Other', color: '#64748B', badge: 'bg-[#64748B]' },
};

export const workTypeMeta = (type) =>
  Object.hasOwn(WORK_TYPES, type) ? WORK_TYPES[type] : WORK_TYPES.other;

export const workTypeLabel = (type) =>
  Object.hasOwn(WORK_TYPES, type) ? WORK_TYPES[type].label : type?.trim() || 'Other';

export function workTypeOptions(types = []) {
  const custom = [...new Set(types.filter(type => type && !Object.hasOwn(WORK_TYPES, type)))].sort();
  return [...Object.keys(WORK_TYPES), ...custom].map(value => ({ value, label: workTypeLabel(value) }));
}

// Keep the existing API/storage format; the optional input is only form state.
export function workTypePayload({ custom_type, ...values }) {
  const custom = custom_type?.trim();
  return {
    ...values,
    type: values.type === 'other'
      ? (custom && Object.hasOwn(WORK_TYPES, custom.toLowerCase()) ? custom.toLowerCase() : custom || 'other')
      : values.type,
  };
}
